import moment from 'moment';
import fetch from 'isomorphic-fetch';
import { checkHttpStatus, parseJSON } from '../utils';
import { CALENDAR_EVENT_FAILURE, CALENDAR_EVENT_REQUEST, CALENDAR_EVENT_SUCCESS } from '../constants';

export function setCalendarEventRequest() {
  return {
    type: CALENDAR_EVENT_REQUEST,
  };
}
export function setCalendarEventSuccess(data) {
  return {
    type: CALENDAR_EVENT_SUCCESS,
    payload: { data },
  };
}
export function setCalendarEventFailure() {
  return {
    type: CALENDAR_EVENT_FAILURE,
  };
}

export function fetchCalendarEvents() {
  return (dispatch) => {
    dispatch(setCalendarEventRequest());
    return fetch(`${SERVER_URL}/events`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const { data: { events = [] } } = response;
        dispatch(setCalendarEventSuccess(events));
      })
      .catch(() => dispatch(setCalendarEventFailure()));
  };
}
